---
title: Rebase Versus Merge
date: 2018-10-31T17:32:28-07:00
draft: true
---

### TL;DR
The main question to ask is "which action will give a clearer understanding of what I did, once I push my changes for others to see and use?". If you made the change recently, just merge it. If some time has passed, rebase it. 

## What’s the difference?
Rebase and merge in Git are usually talked about as a “one or the other" type tool for getting a developers changes into your team’s main branch.  In reality, rebase and merge are tools that serve two very different purposes. What are those purposes?

**Rebase:** take a sequence of one or more sequential changes, and apply them to a new spot in history. 

**Merge:** take all changes since the two branches split, fits them together, and records that result as a new commit. 

So in essence, you are pretending like those commits always existed at that point in time, even though you may have written them long before
This is more of a brute force smushing of two different branches. History is perfectly preserved


## How to choose between the two

### Things to consider
You never re-write shared history. Once something has made it into a remote branch, anything that changes or manipulates history is off limits

Any local history doesn’t matter. You can change it, rearrange it,  squash it into a single commit, whatever you want

### TL;DR
The main question to ask is "which action will give a clearer understanding of what I did, once I push my changes for others to see and use?". If you made the change recently, just merge it. If some time has passed, rebase it. 

### Why should I care?
If you merge when you should have rebased, the change you just introduced will be littered across much older commits, and be harder for someone to track down

If you rebase when you should have just merged, you will lose the point of incorporation between two branches





    - rebase is "pretend I made these changes right now, and just replay them on head". That doesn’t really matter if you really did just do them. Otherwise you have a messy/noisy merge commit randomly. But if your work is recent, then a simple merge doesn’t muck your history up too bad
    - It’s all about which one gives clearer history
    - master branch history is what I consider "important". So when I talk about history, I don’t care about history of individual dev’s feature branches, I care about when they were included in master
    - same with commits. I don’t need to see thirty "fixed typo again, hope CI works this time", squash that junk before merging
    - but once it’s in master, don’t play with it
    - nothing matters until it’s shared, if that makes sense
